import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Col } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import SysControlSideMenuList from './SysControlSideMenuList';
import RestrictionsScreen from './RestrictionsScreen';
import PausingScreen from './PausingScreen';
import ResendOrdersScreen from './ResendOrdersScreen';
import DatabaseContainer from './database/DatabaseContainer';

const SystemControlContainer = props => {

    const { mainContainerStyles, headerColStyles, contentContainerStyles, switchContainerStyles } = styles;

    return (
        <div style={mainContainerStyles}>
            <Col sm={2} style={headerColStyles} >
                <div><MaterialIcon icon="settings" color="#0288d1" size={22} />&nbsp;
                    {i18n.t('screens:restaurantsMainContainer.systemSettings')}</div>
            </Col>

            <div style={contentContainerStyles}>
                <SysControlSideMenuList {...props} />
                <div style={switchContainerStyles}>
                    <Switch>
                        <Route path={`/system-control/restrictions`} component={RestrictionsScreen} />
                        <Route path={`/system-control/orders`} component={ResendOrdersScreen} />
                        <Route path={`/system-control/restaurants`} component={PausingScreen} />
                        <Route path={`/system-control/database`} component={DatabaseContainer} />
                    </Switch>
                </div>
            </div>
        </div>
    );
}

export default SystemControlContainer;

const styles = {
    mainContainerStyles: {
        margin: '20px 24px 0 24px'
    },
    headerColStyles: {
        display: 'flex',
        marginBottom: 4,
        paddingLeft: 0,
        color: '#0288d1'
    },
    contentContainerStyles: {
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        height: '100%',
        width: 'calc(100% - 48px)',
        borderTop: '1px solid #dee2e6'
    },
    switchContainerStyles: {
        width: '100%',
        paddingTop: 20
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/SystemControlContainer.js